module.exports = __webpack_public_path__ + "static/media/homeVNActive.58537354.png";